module.exports = __webpack_public_path__ + "img/yhhx.e3a62a8b.png";